import React from "react";
import { Flex } from "grid-styled";
import { compose } from "redux";
import { reduxForm } from "redux-form";
import { validate as buildValidations } from "validate-redux-form";
import { notEmpty } from "../../utils/validation";
import setInitialValues from "../../hocs/setInitialValues";
import NewSaleOptionsFormSection from "./NewSaleOptionsFormSection";
import SalesDrawingOptionsFormSection from "./SalesDrawingOptionsFormSection";
import Button from "../Button";

const validate = values => {
  let errors;

  if (values.serviceType === "New Sale") {
    errors = {
      ...buildValidations(values, {
        options: {
          serviceLevel: notEmpty()("Please select a service level.")
        }
      })
    };
  }

  return errors;
};

const ServiceOptionsForm = ({
  service,
  cancel,
  onSubmit,
  handleSubmit,
  invalid
}) => {
  const { serviceType } = service;

  const renderFieldsForType = () => {
    if (serviceType === "New Sale") {
      return <NewSaleOptionsFormSection />;
    }

    if (["Sales Drawing", "Redraw"].indexOf(serviceType) > -1) {
      return <SalesDrawingOptionsFormSection />;
    }

    return null;
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {renderFieldsForType()}
      <Flex justify="flex-end">
        {cancel && (
          <Button type="button" onClick={cancel}>
            Cancel
          </Button>
        )}
        <Button
          type="submit"
          primary
          style={{ marginLeft: 4 }}
          disabled={invalid}
        >
          Update Service Options
        </Button>
      </Flex>
    </form>
  );
};

const enhance = compose(
  setInitialValues(({ service: { serviceType, options } }) => ({
    serviceType,
    options: {
      serviceLevel: options.serviceLevel ? `${options.serviceLevel}` : "",
      fullDetailPackage: !!options.fullDetailPackage,
      includeElevations: !!options.includeElevations,
      rush: !!options.rush,
      rushMaterialTakeoff: !!options.rushMaterialTakeoff,
      structuralCalculations: !!options.structuralCalculations,
      pdfStructuralDrawings: !!options.pdfStructuralDrawings,
      consultationRequest: !!options.consultationRequest,
      drawingDepth: options.drawingDepth || "",
      pdfDrawings: !!options.pdfDrawings
    }
  })),
  reduxForm({
    form: "serviceOptions",
    validate
  })
);

export default enhance(ServiceOptionsForm);



// WEBPACK FOOTER //
// ./src/components/services/ServiceOptionsForm.js